import {
  useEffect,
  useState
} from "react";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getCustomers
} from "../../api/customerApi";

import {
  getProducts
} from "../../api/productApi";

import {
  createDispatch
} from "../../api/dispatchApi";

import {
  FaTruck,
  FaPlus,
  FaSave
} from "react-icons/fa";

const Dispatches = () => {

  const [customers, setCustomers] =
    useState([]);

  const [products, setProducts] =
    useState([]);

  const [form, setForm] =
    useState({

      customer_id: "",
      remarks: ""

    });

  const [items, setItems] =
    useState([
      {
        product_id: "",
        quantity: ""
      }
    ]);

  useEffect(() => {

    loadData();

  }, []);

  const loadData =
    async () => {

      try {

        const customerRes =
          await getCustomers();

        const productRes =
          await getProducts();

        setCustomers(
          customerRes.data.data || []
        );

        setProducts(
          productRes.data.data || []
        );

      }
      catch (error) {

        console.log(error);

      }

    };

  const addRow = () => {

    setItems([
      ...items,
      {
        product_id: "",
        quantity: ""
      }
    ]);

  };

  const removeRow =
    (index) => {

      const updated =
        [...items];

      updated.splice(
        index,
        1
      );

      setItems(updated);

    };

  const updateItem =
    (
      index,
      field,
      value
    ) => {

      const updated =
        [...items];

      updated[index][field] =
        value;

      setItems(updated);

    };

  const saveDispatch =
    async (e) => {

      e.preventDefault();

      try {

        await createDispatch({

          customer_id:
            form.customer_id,

          remarks:
            form.remarks,

          items

        });

        alert(
          "Dispatch Saved Successfully"
        );

        setForm({

          customer_id: "",
          remarks: ""

        });

        setItems([
          {
            product_id: "",
            quantity: ""
          }
        ]);

      }
      catch (error) {

        console.log(error);

        alert(
          "Failed To Save Dispatch"
        );

      }

    };

  return (

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header bg-white">

          <div className="d-flex align-items-center">

            <FaTruck
              className="me-2 text-primary"
            />

            <div>

              <h5 className="mb-0">

                Dispatch Entry

              </h5>

              <small className="text-muted">

                Dispatch Finished Goods To Customers

              </small>

            </div>

          </div>

        </div>

        <div className="card-body">

          <form
            onSubmit={saveDispatch}
          >

            <div className="row mb-4">

              <div className="col-md-6">

                <label className="form-label">

                  Customer

                </label>

                <select
                  className="form-select"
                  value={
                    form.customer_id
                  }
                  onChange={(e) =>
                    setForm({
                      ...form,
                      customer_id:
                        e.target.value
                    })
                  }
                >

                  <option value="">
                    Select Customer
                  </option>

                  {
                    customers.map(
                      customer => (

                        <option
                          key={
                            customer.id
                          }
                          value={
                            customer.id
                          }
                        >

                          {
                            customer.customer_name
                          }

                        </option>

                      )
                    )
                  }

                </select>

              </div>

              <div className="col-md-6">

                <label className="form-label">

                  Remarks

                </label>

                <input
                  type="text"
                  className="form-control"
                  value={
                    form.remarks
                  }
                  onChange={(e) =>
                    setForm({
                      ...form,
                      remarks:
                        e.target.value
                    })
                  }
                />

              </div>

            </div>

            <div className="table-responsive">

              <table className="table table-bordered">

                <thead className="table-light">

                  <tr>

                    <th width="70%">
                      Product
                    </th>

                    <th width="20%">
                      Qty
                    </th>

                    <th width="10%">
                      Action
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {
                    items.map(
                      (
                        item,
                        index
                      ) => (

                        <tr
                          key={index}
                        >

                          <td>

                            <select
                              className="form-select"
                              value={
                                item.product_id
                              }
                              onChange={(e) =>
                                updateItem(
                                  index,
                                  "product_id",
                                  e.target.value
                                )
                              }
                            >

                              <option value="">
                                Select Product
                              </option>

                              {
                                products.map(
                                  product => (

                                    <option
                                      key={
                                        product.id
                                      }
                                      value={
                                        product.id
                                      }
                                    >

                                      {
                                        product.product_name
                                      }

                                    </option>

                                  )
                                )
                              }

                            </select>

                          </td>

                          <td>

                            <input
                              type="number"
                              className="form-control"
                              value={
                                item.quantity
                              }
                              onChange={(e) =>
                                updateItem(
                                  index,
                                  "quantity",
                                  e.target.value
                                )
                              }
                            />

                          </td>

                          <td>

                            {
                              items.length > 1 &&
                              (

                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() =>
                                    removeRow(
                                      index
                                    )
                                  }
                                >

                                  ×

                                </button>

                              )
                            }

                          </td>

                        </tr>

                      )
                    )
                  }

                </tbody>

              </table>

            </div>

            <div className="d-flex justify-content-between mt-3">

              <button
                type="button"
                className="btn btn-secondary"
                onClick={addRow}
              >

                <FaPlus />

                {" "}

                Add Product

              </button>

              <button
                type="submit"
                className="btn btn-primary"
              >

                <FaSave />

                {" "}

                Save Dispatch

              </button>

            </div>

          </form>

        </div>

      </div>

    </MainLayout>

  );

};

export default Dispatches;